<template>
  <Overlay v-if="isLoadingInspection" />
  <div class="custom-overview">
    <h4 class="text-center mb-4">Generate New Vehicle ADAS Systems &amp; Calibrations Overview</h4>
    <OverviewForm @open="actionBlueprint = $event" />
  </div>
  <DialogBlueprint v-model="actionBlueprint" @report="openReport" @closing="closeModal" />
  <DialogInspectionReport v-model="actionReport" :title="reportTitle" @closing="closeReportModal" />
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { authStore } from '@/stores/auth'
import { inspectionStore } from '@/stores/inspection'
import { locationStore } from '@/stores/location'
import Overlay from '@/components/utilities/elements/Overlay.vue'
import OverviewForm from '@/components/blueprint/forms/OverviewForm.vue'
import DialogBlueprint from '@/components/blueprint/forms/DialogBlueprint.vue'
import DialogInspectionReport from '@/components/blueprint/report/InspectionReport.vue'
// #668: VIN overview page; the result opens in the Repairs inspection dialog.
export default {
  name: 'OverviewView',
  components: {
    Overlay,
    OverviewForm,
    DialogBlueprint,
    DialogInspectionReport
  },
  data() {
    return {
      actionBlueprint: null,
      actionReport: null,
      reportTitle: null
    }
  },
  async mounted() {
    // The dialog reads these, so load them the same way the Repairs page does.
    this.resetPreferences()
    for (const name of ['isInsurer', 'isPartOfProviderPrograms', 'optOutOthersBPCP', 'isDontAllowBPCPShareChecks']) {
      await this.getPreferences({ firm: this.profile.firm, category: 'General', name })
    }
  },
  computed: {
    ...mapState(authStore, ['profile']),
    ...mapState(inspectionStore, ['loading']),
    isLoadingInspection() {
      return this.loading.inspection
    }
  },
  methods: {
    ...mapActions(locationStore, ['resetPreferences', 'getPreferences']),
    closeModal() {
      this.actionBlueprint = null
      this.actionReport = null
      this.reportTitle = null
    },
    closeReportModal() {
      this.actionReport = null
      this.reportTitle = null
    },
    openReport(data) {
      this.reportTitle = `# ${data.adasInspection}`
      this.actionReport = data
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-overview {
  padding-top: 1rem;
}
</style>
